import ROSEATE from "@/assets/industry-co-led/partners/ROSEATE.png";
import MARRIOTT from "@/assets/industry-co-led/partners/MARRIOTT.png";
import NEPHROPLUS from "@/assets/industry-co-led/partners/NEPHROPLUS.png";
import EMVERSITY from "@/assets/industry-co-led/partners/EMVERSITY.png";
import REDVERSITY from "@/assets/industry-co-led/partners/REDVERSITY.png"

import Img1 from "@/assets/industry-co-led/image/image-1.png"
import Img2 from "@/assets/industry-co-led/image/image-2.png"
import Img3 from "@/assets/industry-co-led/image/image-3.png"
import Img4 from "@/assets/industry-co-led/image/image-4.png"

export const ICL_PG_Programmes = {
    "categories": [
        "All",
        // "Emversity",
        "Redversity",
        // "Nephroplus",
        // "Marriott & Roseate"
    ],
    "programmes": [

        {
            "id":1,
            "title": "Master of Advanced Care Paramedic",
            "category": "Redversity",
            "image": Img1,
            "poweredBy": REDVERSITY,
            "url": "/industry-co-led-pg-programmes/redversity/master-of-advanced-care-paramedic",
        },
        {
            "id": 2,
            "title": "MBA in Healthcare Management",
            "category": "Redversity",
            "image": Img2,
            "poweredBy": REDVERSITY,
            "url": "/industry-co-led-pg-programmes/redversity/mba-in-healthcare-management",
        },

    ]
}